module.exports = __webpack_public_path__ + "static/media/megasearchlist.741dfa59.png";